<template>
  <div class="wrapper" id="login">
    <div class="login-content d-flex justify-content-center">
      <div class="inner d-flex flex-column justify-content-between">
        <img src="/static/als-logo.png" class="branding" al="ALS Logo">
        <div class="login-form">
          <h2>Password reset</h2>
          <p>We've sent you an email with a link to reset your password.</p>

          <div class="form-group">
            <button type="button" class="btn btn-success btn-block" @click="backToLogin" id="backtologinButton">Back to login page</button>
          </div>
        </div>

        <div class="copyright-footer">&copy; 2024 Analytica Laboratories Limited T/A ALS NZ</div>
      </div>
    </div>
    <div class="login-image"></div>
  </div>
</template>

<script>

import router from '@/router';

export default {
  name: 'ResetPassword',
  methods: {
    backToLogin: () => {
      router.push('login');
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";

.wrapper {
  height: 100vh;
}

.login-content {
  height: 100%;
  width: 50%;
  float: left;
  h2 {
    margin-bottom: 20px;
  }
  .branding {
    width: 200px;
  }
  .inner {
    width: 500px;
    height: 100%;
    padding: 50px;
  }
}

.login-image {
  position: relative;
  background-image: url("../../static/login-photo.jpg");
  background-size: cover;
  background-position: 50% 50%;
  height: 100%;
  width: 50%;
  float: left;
  z-index: 1;
  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: -webkit-linear-gradient(bottom, $brand-primary, $brand-gray);
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue